import Layout from 'antd/lib/layout/layout'
import styled from 'styled-components'
import { Row } from 'antd'

export const StyledLayout = styled(Layout)`
    height: 100vh;
    overflow-y: scroll;
`
export const CustomRow = styled(Row)`
    height: 100vh;
`
